import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=b1b12790&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports